import { GetAllPersonaleContabileFiltersDTO, GetAllPersonaleContabileResponseData } from "./dto";
import { PersonaleContabileImpl } from "./serviceImpl";

export interface PersonaleContabileService {
    GetAllPersonaleContabile(filters: GetAllPersonaleContabileFiltersDTO): Promise<GetAllPersonaleContabileResponseData[]>
}

export function NewPersonaleContabileService(): PersonaleContabileService {
    return new PersonaleContabileImpl()
}